import {
	MODULE_NAME,
	LOGS,
	LOADING_LOGS,
	SET_LOGS,
	SET_USERS_LOGS,
	USERS_LOGS,
	SECUREVUE_TRANSACTIONS,
	SET_SECUREVUE_TRANSACTIONS
} from './logs-mutation-type';

import { TOAST_MESSAGES_PUSH } from '@/sections/toast-mutation-types.js';

import { ApiLogService as api } from '@/services/axiosHelper';
import { ApiService as supportApi } from '@/services/axiosHelper';
import buildRoute from '@/composables/build-route';
import _ from 'lodash';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: MODULE_NAME,
	namespaced: true,
	state: {
		[LOGS]: {},
		[SECUREVUE_TRANSACTIONS]: {},
		[USERS_LOGS]: {},
		[LOADING_LOGS]: false
	},
	mutations: {
		[SET_LOGS](state, data) {
			state[LOGS] = data;
		},
		[SET_SECUREVUE_TRANSACTIONS](state, data) {
			state[SECUREVUE_TRANSACTIONS] = data;
		},
		[SET_USERS_LOGS](state, data) {
			state[USERS_LOGS] = data;
		},
		[LOADING_LOGS](state, data) {
			state[LOADING_LOGS] = data;
		}
	},
	actions: {
		async setLogs({ commit, dispatch }, params) {
			commit(LOADING_LOGS, true);
			commit(SET_LOGS, {});

			const valuesToRemove = [undefined, '', 'all'];
			params = _.omitBy(params, value => valuesToRemove.includes(value));

			return new Promise((resolve, reject) => {
				supportApi
					.post('/versionhistory', params)
					.then(res => {
						commit(SET_LOGS, res);
						resolve();
					})
					.catch(err => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: err
							},
							{
								root: true
							}
						);
						reject();
					});
			});
		},
		async [SET_USERS_LOGS]({ commit }, parameters) {
			const results = await api.get(buildRoute(`/users`, parameters));
			commit(SET_USERS_LOGS, results);
		},
		async setSecurevueTransactions({ commit }, parameters) {
			const results = await api.get(
				buildRoute(`/securevue/transactions`, parameters)
			);
			commit(SET_SECUREVUE_TRANSACTIONS, results);

			return results;
		}
	},
	getters: {
		[LOGS]: state => state[LOGS],
		[LOADING_LOGS]: state => state[LOADING_LOGS],
		[SECUREVUE_TRANSACTIONS]: state => state[SECUREVUE_TRANSACTIONS],
		[USERS_LOGS]: state => state[USERS_LOGS]
	}
};
